import { FC } from 'react';
import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import Button, { ButtonProps } from '@mui/material/Button';
import makeStyles from '@mui/styles/makeStyles';

export type SvgIconButtonProps = Omit<ButtonProps, 'aria-label'> & {
  iconProps: FontAwesomeIconProps;
  ariaLabel: string;
  pulsing?: boolean;
};

const SvgIconButton: FC<SvgIconButtonProps> = ({
  className,
  disabled,
  ariaLabel,
  onClick,
  iconProps,
  pulsing = false,
  ...props
}) => {
  const classes = useStyles();

  return (
    <Button
      className={`${className} ${pulsing ? classes.pulsing : ''}`}
      disabled={disabled}
      aria-label={ariaLabel}
      onClick={onClick}
      sx={{
        '&.Mui-focusVisible .MuiTouchRipple-child': {
          backgroundColor: '#4e4d4d',
        },
      }}
      {...props}
    >
      <FontAwesomeIcon color={disabled ? 'inherit' : 'black'} {...iconProps} />
    </Button>
  );
};

export default SvgIconButton;

const useStyles = makeStyles(() => ({
  pulsing: {
    animation: `$pulse 1.2s infinite`,
  },
  '@keyframes pulse': {
    '0%': {
      transform: 'scale(.90)',
    },
    '50%': {
      transform: 'scale(1.2)',
    },
    '100%': {
      transform: 'scale(.90)',
    },
  },
}));
